module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/175/assets/images/e9e1d777d8487e62d7d8f48d196b1ce9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_icon_video.svg
// module id = 3lbZ
// module chunks = 1